'use strict';

import _ from 'lodash';

import * as courseList from '../actions/publicCourseList';

var defaultState = {
    modules: [],
    expandedModules: []
};

function addModuleToExpanded(expandedModules, moduleToExpand) {

    return expandedModules.concat([moduleToExpand]);
}

function removeModuleFromExpanded(expandedModules, moduleToExpand) {

    return _.filter(expandedModules, function(moduleId) {

        return moduleId !== moduleToExpand;
    })
}

function getExpandedModulesOnToggle(expandedModules, toggledModuleId) {

    if (!_.includes(expandedModules, toggledModuleId)) {

        return addModuleToExpanded(expandedModules, toggledModuleId);

    } else {

        return removeModuleFromExpanded(expandedModules, toggledModuleId);
    }
}

export default function(state = defaultState, action) {

    switch (action.type) {

        case courseList.PUBLIC_COURSES_REFRESHED:

            return {
                ...state,
                modules: action.modules
            };

        case courseList.TOGGLE_MODULE_VISIBILITY:

            return {
                ...state,
                expandedModules: getExpandedModulesOnToggle(state.expandedModules, action.moduleId)
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/publicCourseList.js